module.exports = "/images/airconditioning.jpg?07216f13cc9cd9a469cf19c910c2e1b1";